import { name } from "./modal.reducers";

export const selectSlice = (state) => state[name];

export const selectSelectedModal = (state) => selectSlice(state).selectedModal;

export const selectItemToBeDeleted = (state) =>
  selectSlice(state).itemToBeDeleted;

export const selectShouldShowDeploymentModal= (state) =>
  selectSlice(state).shouldShowDeploymentModal;
